export default "__VITE_ASSET__BpOIbRTP__"